import { PromotionShowProps } from "@/types/types"
import { usePage } from "@inertiajs/react"
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/20/solid"
import { localeDetailFor, promotionCopyFor } from "@/utils/promotionLocale"

const TweetSubmissions = ({ locale }: { locale: string }) => {
  const {
    promotion: { tweets },
  } = usePage<PromotionShowProps>().props

  if (tweets.length === 0) {
    return null
  }

  const copy = promotionCopyFor(locale)

  return (
    <div className="mt-10">
      <div className="mb-4 flex items-baseline justify-between gap-4">
        <h3 className="text-lg font-bold text-stone-950">
          {copy.submittedTweets}
        </h3>
        <span className="text-sm font-medium text-stone-500">
          {tweets.length}
        </span>
      </div>
      <div>
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3">
          {tweets.map((tweet, index) => (
            <a
              key={tweet.tweet_id}
              href={tweet.url}
              target="_blank"
              rel="noreferrer noopener"
              className="focus-visible:outline-chessdrop-500 group flex min-w-0 items-center rounded-lg border border-stone-200 bg-white px-3 py-3 shadow-xs transition-colors hover:border-stone-400 focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              <span className="mr-3 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-stone-100 text-sm font-bold text-stone-600">
                {index + 1}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-semibold text-stone-900">
                  @{tweet.tweet_username}
                </span>
                <span className="block truncate text-sm text-stone-500">
                  {new Intl.DateTimeFormat(localeDetailFor(locale).dateLocale, {
                    dateStyle: "long",
                  }).format(new Date(tweet.created_at))}
                </span>
              </span>
              <ArrowTopRightOnSquareIcon
                className="ml-2 h-4 w-4 shrink-0 text-stone-400 group-hover:text-stone-700"
                aria-hidden="true"
              />
            </a>
          ))}
        </div>
      </div>
    </div>
  )
}

export default TweetSubmissions
